function changeJavascript(document, javascript) {
  const head = document.getElementsByTagName('head').item(0) || document.head
  const headValue = document.createRange().createContextualFragment(javascript.head)
  head.appendChild(headValue)
  const body = document.getElementsByTagName('body').item(0) || document.body
  const bodyValue = document.createRange().createContextualFragment(javascript.body)
  body.appendChild(bodyValue)
}

export { changeJavascript }
